import { useMemo } from "react";
import { useAppSession } from "./useAppSession";
import type { AdminRole, AdminSessionUserDto } from "../types/adminSession.api";

function normalizeAdminRole(value: unknown): AdminRole | null {
  if (value === "client" || value === "admin" || value === "superadmin") {
    return value;
  }

  return null;
}

export function useAdminSessionSummary() {
  const sessionState = useAppSession();
  const sessionUser = useMemo(
    () =>
      sessionState.data?.user
        ? ({
            id: (sessionState.data.user as { id?: string | null }).id ?? null,
            name:
              (sessionState.data.user as { name?: string | null }).name ?? null,
            email:
              (sessionState.data.user as { email?: string | null }).email ??
              null,
            image:
              (sessionState.data.user as { image?: string | null }).image ??
              null,
            role: normalizeAdminRole(
              (sessionState.data.user as { role?: unknown }).role,
            ),
          } satisfies AdminSessionUserDto)
        : null,
    [sessionState.data?.user],
  );

  return useMemo(
    () => ({
      isLoading: sessionState.isPending,
      refetch: sessionState.refetch,
      sessionUser,
    }),
    [sessionState.isPending, sessionState.refetch, sessionUser],
  );
}
